<template>
  <div>
    <ContentHeader :showBack="true" />
    <div class="content-container" v-loading="loading">
      <div class="title">
        <span>主题信息</span>
        <template v-if="employeeLevel === 90">
          <div class="handle-box" v-if="info.publishStatus === 1 && info.themeStatus !== 900">
            <!-- <el-button class="btn-red" :loading="bthLoading" @click="handleUpdate" v-if="info.themeStatus !== 200">修改</el-button> -->
            <el-button class="btn-red" :loading="bthLoading" @click="handleDisable">禁用</el-button>
          </div>
          <div class="handle-box" v-if="info.publishStatus === 0">
            <el-button class="btn-red" :loading="bthLoading" @click="handleEnable">启用</el-button>
          </div>
        </template>
      </div>
      <div class="detail-info">
        <div class="detail-item">
          <div class="item-name">主题名称</div>
          <div class="item-value">{{info.themeName}}</div>
        </div>
        <div class="detail-item">
          <div class="item-name">渠道</div>
          <div class="item-value">{{info.channelName}}</div>
        </div>
        <div class="detail-item">
          <div class="item-name">活动时间</div>
          <div class="item-value">{{info.startDate | parseTime('{y}-{m}-{d}')}} 至 {{info.endDate | parseTime('{y}-{m}-{d}')}}</div>
        </div>
        <div class="detail-item">
          <div class="item-name">所属组织级别</div>
          <div class="item-value">总部</div>
        </div>
        <div class="detail-item">
          <div class="item-name">陈列追踪方式</div>
          <div class="item-value">{{info.trackTypeNameScope}}</div>
        </div>
        <div class="detail-item">
          <div class="item-name">最少执行时间（天）</div>
          <div class="item-value">{{info.execDaysMin}}</div>
        </div>
        <div class="detail-item">
          <div class="item-name">最低打卡频次（天/次）</div>
          <div class="item-value">{{info.execDaysCycle}}</div>
        </div>
        <div class="detail-item">
          <div class="item-name">可执行任务范围</div>
          <div class="item-value">{{info.taskTypeNameScope}}</div>
        </div>
                <div class="detail-item" style="flex-basis:100%">
          <div class="item-name" style="flex-basis:12%">费用返还方式</div>
          <div class="item-value" style="flex-basis:88%;display:flex;flex-wrap:wrap">
            {{info.bonusTypeNameScope}}
            <i v-if="info.bonusTypeNameScope && info.beesBonusTypeNameScope">,</i>
            {{info.beesBonusTypeNameScope}}
          </div>
        </div>
      </div>
      <!-- 操作记录 -->
      <div class="title">
        <span>操作记录</span>
      </div>
      <div class="handle-history">
        <el-table :data="history" style="width: 100%" :border="true">
          <el-table-column prop="processClientName" label="操作人" align="center">
            <template #default="scope">
              <div>{{scope.row.employeeLevelName + ' - ' + scope.row.processClientName}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="processActionName" label="操作" align="center"></el-table-column>
          <el-table-column prop="processRemark" label="备注" align="center"></el-table-column>
          <el-table-column prop="processTime" label="时间" align="center">
            <template #default="scope">{{scope.row.processTime | parseTime("{y}-{m}-{d} {h}:{i}:{s}")}}</template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from '@/components/content-header'
import { mapGetters } from 'vuex'
import tradeApi from '@/api/trade.js'
export default {
  components: {
    ContentHeader
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  data () {
    return {
      loading: false,
      bthLoading: false,
      history: [],
      themeDefineId: '',
      info: {}
    }
  },
  created () {
    this.employeeLevel = this.userInfo.employeeLevel
    this.themeDefineId = this.$route.query.themeDefineId
    this.getThemeDefineHqInfo()
  },
  methods: {
    // 获取活动详情
    getThemeDefineHqInfo () {
      tradeApi.getThemeDefineHqInfo({ themeDefineId: this.themeDefineId }).then(res => {
        if (res.data.resultCode === '0') {
          this.info = res.data.resultData.themeDefineInfo
          this.history = res.data.resultData.themeDefineInfo.commonProcessRecordDTOList
        }
      })
    },
    // handleUpdate () {
    //   this.$router.push({
    //     path: '/trade/perfect-hq-config',
    //     query: { type: '02', themeDefineId: this.info.themeDefineId }
    //   })
    // },
    // 禁用
    handleDisable () {
      this.bthLoading = true
      this.$prompt('请输入禁用原因:', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S+/,
        inputErrorMessage: '请输入禁用原因'
      }).then(({ value }) => {
        if (!value) {
          this.$message.warning('请填写禁用原因')
          return
        }
        tradeApi.perfectDisabled({ themeDefineId: this.info.themeDefineId, processRemark: value }).then(res => {
          this.bthLoading = false
          if (res.data.resultCode === '0') {
            this.$message.success('禁用成功')
            this.$router.go(0)
          }
        })
      }).catch(() => {
        this.bthLoading = false
      })
    },

    // 启用
    handleEnable () {
      this.bthLoading = true
      this.$prompt('请输入启用备注:', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        tradeApi.perfectEnable({ themeDefineId: this.info.themeDefineId, processRemark: value }).then(res => {
          this.bthLoading = false
          if (res.data.resultCode === '0') {
            this.$message.success('启用成功')
            this.$router.go(0)
          }
        })
      }).catch(() => {
        this.bthLoading = false
      })
    }

  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-step__title.is-process,
::v-deep .el-step__head.is-process {
  color: #cd1231;
  border-color: #cd1231;
  font-weight: 400;
}
::v-deep .el-step__head.is-success,
::v-deep .el-step__head.is-process {
  font-size: 14px;
}
.el-button {
  width: 50px;
  height: 30px;
  padding: 0;
}
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    font-size: 18px;
    font-weight: 700;
    line-height: 60px;
    padding-left: 10px;
  }
}
.detail-info {
  display: flex;
  flex-wrap: wrap;
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 40px;
  .detail-item {
    width: 50%;
    display: flex;
    .item-name {
      width: 130px;
      height: 48px;
      flex-basis: 25%;
    }
    .item-value {
      flex-basis: 70%;
    }
  }
}
.task {
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 10px;
  .task-title {
    font-size: 16px;
    margin-bottom: 30px;
  }
  .task-item {
    margin-bottom: 30px;
  }
}
.handle-history {
  background-color: #fff;
  border-radius: 10px;
  padding: 30px;
}
</style>
